// @ts-ignore
import React from 'react';

interface SkeletonProps {
    className?: string;
}

export default function Skeleton({ className }: SkeletonProps) {
    return (
        <div className={`animate-pulse bg-gray-100 rounded-md ${className}`} />
    );
}
